import * as angular from 'angular';
import * as $ from 'jquery';
import { clamp } from 'lodash';

export default class FillerbusterController {
  // bindings
  token: string;
  fontSizeMax: number;
  fontSizeMin: number;
  fontName: string;
  content: string;
  // local
  canvas;
  shouldAddLink: boolean;
  chartUrl: string;
  // for testing purposes
  $;

  static $inject = ['$window', '$element', '$scope'];

  constructor(
    private $window: angular.IWindowService,
    private $element: angular.IAugmentedJQuery,
    private $scope: angular.IScope
  ) {
    this.$ = $;
  }

  $onInit() {
    // Alamode was attempting to replace the span outside of the Angular lifecycle
    // which was causing inconsistent loading of the big value chart values.
    // By attaching an object to the window with the chartIds and their corresponding
    // URLs, we can check for those values from within the Angular lifecycle
    // to ensure that the links are consistently replaced and filter functionality
    // is intact after the chart values are updated
    this.shouldAddLink = false;
    const chartToken = this.token;
    const interval = setInterval(() => {
      const alaModeCharts = this.$window['ALAMODE_CHARTS'];
      if (alaModeCharts && alaModeCharts[chartToken]) {
        this.$scope.$evalAsync(() => {
          this.shouldAddLink = true;
          this.chartUrl = alaModeCharts[chartToken];
        });
        clearInterval(interval);
      }
    }, 500);
  }

  $onChanges = () => {
    this.updateUI();
  };

  $postLink = () => {
    this.initWatchers();
    this.initCSS();
    this.updateUI();
    this.bindResizeHandler();
  };

  $onDestroy = () => {
    this.unbindResizeHandler();
  };

  initWatchers() {
    this.$scope.$watch(
      () => this.$element.outerWidth(),
      (next, prev) => {
        if (next !== prev) {
          this.updateUI();
        }
      }
    );
  }

  initCSS() {
    const maxDimensionsCSS = {
      display: 'block',
      width: '100%',
      height: '100%',
    };

    this.$element.css(maxDimensionsCSS);
    this.containerEl().css(maxDimensionsCSS);
  }

  updateUI() {
    this.updateFontSize(this.containerEl(), px(this.calculateFontSize()));
  }

  updateFontSize($elem, fontSize) {
    $elem.css({ fontSize });
  }

  containerEl() {
    return this.$element.find('.fb-container');
  }

  calculateFontSize() {
    const fontSizeScalar = 1;
    const containerWidth = this.$element.outerWidth();
    const fontBase = this.measureFontBase(this.content, fontSizeScalar, this.fontName);
    const scaledFontSize = this.scaleFontSize(fontSizeScalar, fontBase, containerWidth);

    return clamp(scaledFontSize, this.fontSizeMin, this.fontSizeMax);
  }

  measureFontBase(text, fontSize, fontName): number {
    this.canvas = this.canvas || window.document.createElement('canvas');

    let fontBase = this.measureCanvasText(this.canvas, text, fontSize, fontName);

    // For very small text content, the canvas can get confused and return decimals
    // less than one or even zero. Ensure it's always at least 1.
    // See: https://github.com/mode/webapp/pull/9433
    if (!fontBase || fontBase < 1) {
      fontBase = 1;
    }
    return fontBase;
  }

  measureCanvasText(canvas, text, fontSize, fontName): number {
    const font = `${fontSize}px ${fontName}`;
    const cxt = canvas.getContext('2d');

    cxt.font = font;
    return cxt.measureText(text).width;
  }

  scaleFontSize(fontSize, fontBase, containerWidth): number {
    const ratio = fontSize / fontBase;
    const size = containerWidth * ratio;

    return size | 0;
  }

  bindResizeHandler() {
    this.$(this.$window).on(this.eventNS('resize'), this.updateUI.bind(this));
  }

  unbindResizeHandler() {
    this.$(this.$window).off(this.eventNS('resize'));
  }

  eventNS(name) {
    return name + '.fb';
  }
}

function px(num) {
  return `${num}px`;
}
